import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path, Rect} from 'react-native-svg';
import {getButtonDescriber} from 'src/components/elements/buttonDescriptor/DescriptorType';
import Settings from 'src/Settings';
type LogoProps = {
  size: number;
  style?: Record<string, unknown>;
}; // tslint:disable

export default class PaperBillPinkTint extends React.Component<LogoProps> {
  getWidth() {
    if (this.props.style && this.props.style['size']['width']) {
      return this.props.style['size']['width'];
    } else {
      return 22;
    }
  }

  getHeight() {
    if (this.props.style && this.props.style['size']['height']) {
      return this.props.style['size']['height'];
    } else {
      return 20;
    }
  }

  render() {
    return (
      <>
        <Svg
          width={this.getWidth()}
          height={this.getHeight()}
          viewBox="0 0 22 20"
          fill="none"
        >
          <G clip-path="url(#clip0_13625_919)">
            <Path
              d="M19.4167 4.0625C20.062 4.0625 20.5833 4.59316 20.5833 5.25V6.4375C19.2964 6.4375 18.25 5.37246 18.25 4.0625H19.4167ZM5.41667 4.0625H17.0833C17.0833 6.0293 18.651 7.625 20.5833 7.625V12.375C18.651 12.375 17.0833 13.9707 17.0833 15.9375H5.41667C5.41667 13.9707 3.84896 12.375 1.91667 12.375V7.625C3.84896 7.625 5.41667 6.0293 5.41667 4.0625ZM1.91667 13.5625C3.20365 13.5625 4.25 14.6275 4.25 15.9375H3.08333C2.43802 15.9375 1.91667 15.4068 1.91667 14.75V13.5625ZM18.25 15.9375C18.25 14.6275 19.2964 13.5625 20.5833 13.5625V14.75C20.5833 15.4068 20.062 15.9375 19.4167 15.9375H18.25ZM4.25 4.0625C4.25 5.37246 3.20365 6.4375 1.91667 6.4375V5.25C1.91667 4.59316 2.43802 4.0625 3.08333 4.0625H4.25ZM3.08333 2.875C1.79635 2.875 0.75 3.94004 0.75 5.25V14.75C0.75 16.06 1.79635 17.125 3.08333 17.125H19.4167C20.7036 17.125 21.75 16.06 21.75 14.75V5.25C21.75 3.94004 20.7036 2.875 19.4167 2.875H3.08333ZM10.0833 8.21875C10.0833 8.54531 10.3458 8.8125 10.6667 8.8125V11.1875H10.375C10.0542 11.1875 9.79167 11.4547 9.79167 11.7812C9.79167 12.1078 10.0542 12.375 10.375 12.375H11.25H12.125C12.4458 12.375 12.7083 12.1078 12.7083 11.7812C12.7083 11.4547 12.4458 11.1875 12.125 11.1875H11.8333V8.21875C11.8333 7.89219 11.5708 7.625 11.25 7.625H10.6667C10.3458 7.625 10.0833 7.89219 10.0833 8.21875ZM7.75 10C7.75 9.05517 8.11875 8.14903 8.77513 7.48093C9.4315 6.81283 10.3217 6.4375 11.25 6.4375C12.1783 6.4375 13.0685 6.81283 13.7249 7.48093C14.3813 8.14903 14.75 9.05517 14.75 10C14.75 10.9448 14.3813 11.851 13.7249 12.5191C13.0685 13.1872 12.1783 13.5625 11.25 13.5625C10.3217 13.5625 9.4315 13.1872 8.77513 12.5191C8.11875 11.851 7.75 10.9448 7.75 10ZM15.9167 10C15.9167 8.74022 15.425 7.53204 14.5498 6.64124C13.6747 5.75044 12.4877 5.25 11.25 5.25C10.0123 5.25 8.82534 5.75044 7.95017 6.64124C7.075 7.53204 6.58333 8.74022 6.58333 10C6.58333 11.2598 7.075 12.468 7.95017 13.3588C8.82534 14.2496 10.0123 14.75 11.25 14.75C12.4877 14.75 13.6747 14.2496 14.5498 13.3588C15.425 12.468 15.9167 11.2598 15.9167 10Z"
              fill={getButtonDescriber().checkRoundedBtnColor()}
            />
          </G>
          <Defs>
            <ClipPath id="clip0_13625_919">
              <Rect
                width="21"
                height="19"
                fill="white"
                transform="translate(0.75 0.5)"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </>
    );
  }
}
